/**
 * Menu Tab Constants
 * Predefined pages for menu linking
 */

// Predefined pages that can be linked
export const PREDEFINED_PAGES = [
  // Main Pages
  { name: "Home", href: "/", type: "internal", group: "Main" },
  { name: "Schedule", href: "/schedule", type: "internal", group: "Main" },
  { name: "On Demand", href: "/on-demand", type: "internal", group: "Main" },
  { name: "News", href: "/news", type: "internal", group: "Main" },
  { name: "Podcasts", href: "/podcasts", type: "internal", group: "Main" },
  { name: "Photos", href: "/photos", type: "internal", group: "Main" },
  { name: "Record Book", href: "/record-book", type: "internal", group: "Main" },
  { name: "Events", href: "/events", type: "internal", group: "Main" },
  { name: "Watch", href: "/watch", type: "internal", group: "Main" },
  { name: "Guide", href: "/guide", type: "internal", group: "Main", protected: true },
  
  // System Dropdowns (with icons)
  { name: "Channels (Dropdown)", href: "/channels", type: "system", group: "System", icon: "Radio", has_dropdown: true },
  { name: "Leagues (Dropdown)", href: "/leagues", type: "system", group: "System", icon: "Trophy", has_dropdown: true },
  
  // Channels & Media
  { name: "Channels", href: "/channels", type: "internal", group: "Media" },
  { name: "Live", href: "/live", type: "internal", group: "Media" },
  { name: "Galleries", href: "/galleries", type: "internal", group: "Media" },
  { name: "Watch Party", href: "/watch-party", type: "internal", group: "Media" },
  
  // Events & Sports
  { name: "Events", href: "/events", type: "internal", group: "Events" },
  { name: "Leagues", href: "/leagues", type: "internal", group: "Events" },
  { name: "Brackets", href: "/brackets", type: "internal", group: "Events" },
  { name: "Leagues", href: "/leagues", type: "internal", group: "Events" },
  
  // User Pages
  { name: "Sign Up", href: "/signup", type: "internal", group: "User" },
  { name: "Sign In", href: "/login-user", type: "internal", group: "User" },
  { name: "My Account", href: "/account", type: "internal", group: "User" },
  
  // Info Pages
  { name: "About", href: "/about", type: "internal", group: "Info" },
  { name: "Contact", href: "/contact", type: "internal", group: "Info" },
  { name: "Careers", href: "/careers", type: "internal", group: "Info" },
  { name: "Advertise", href: "/sponsor/signup", type: "internal", group: "Info" },
  { name: "Privacy Policy", href: "/privacy", type: "internal", group: "Info" },
  { name: "Terms of Service", href: "/terms", type: "internal", group: "Info" },
  
  // Portals
  { name: "Admin Dashboard", href: "/admin", type: "internal", group: "Portals" },
  { name: "Writer Portal", href: "/writer/login", type: "internal", group: "Portals" },
  { name: "Sponsor Portal", href: "/sponsor/login", type: "internal", group: "Portals" },
  { name: "Photographer Portal", href: "/photographer/login", type: "internal", group: "Portals" },
  
  // Custom
  { name: "Custom Link", href: "", type: "custom", group: "Custom" },
];
